/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type InvsysListingCurrencyCodeType = 'AUD' | 'CAD' | 'USD' | '%future added value';
export type InvsysSizeUnitType = 'CENTIMETERS' | 'INCHES' | '%future added value';
export type InvsysWeightUnitType = 'GRAMS' | 'KILOGRAMS' | 'OUNCES' | 'POUNDS' | '%future added value';
export type InvsysListingCurrencyCodeTypePutObject = {
  value?: InvsysListingCurrencyCodeType | null;
};
export type InvsysSizeUnitTypePutObject = {
  value?: InvsysSizeUnitType | null;
};
export type InvsysWeightUnitTypePutObject = {
  value?: InvsysWeightUnitType | null;
};
export type InvsysFloatPutObject = {
  value?: number | null;
};
export type InvsysArray_IntRequired_PutObject = {
  value?: Array<number> | null;
};
export type InvsysStringPutObject = {
  value?: string | null;
};
export type InvsysIntPutObject = {
  value?: number | null;
};
export type putListingFeatureSettingsMutationVariables = {
  currencyCode?: InvsysListingCurrencyCodeTypePutObject | null;
  sizeUnit?: InvsysSizeUnitTypePutObject | null;
  weightUnit?: InvsysWeightUnitTypePutObject | null;
  weight?: InvsysFloatPutObject | null;
  shippingProviders?: InvsysArray_IntRequired_PutObject | null;
  descriptionTemplate?: InvsysStringPutObject | null;
  privateNoteTemplate?: InvsysStringPutObject | null;
  packageSizeType?: InvsysIntPutObject | null;
  packageCustomLength?: InvsysFloatPutObject | null;
  packageCustomWidth?: InvsysFloatPutObject | null;
  packageCustomHeight?: InvsysFloatPutObject | null;
  marketplaces?: InvsysArray_IntRequired_PutObject | null;
  poshmarkShippingDiscountId?: InvsysStringPutObject | null;
  mercariShippingType?: InvsysIntPutObject | null;
  mercariShippingPayerId?: InvsysIntPutObject | null;
  depopShippingType?: InvsysIntPutObject | null;
  depopNationalShippingPrice?: InvsysIntPutObject | null;
  depopInternationalShippingPrice?: InvsysIntPutObject | null;
  tradesyShippingType?: InvsysIntPutObject | null;
  tradesyShippingPrice?: InvsysIntPutObject | null;
  grailedShippingType?: InvsysIntPutObject | null;
  grailedUsShippingPrice?: InvsysIntPutObject | null;
  grailedCaShippingPrice?: InvsysIntPutObject | null;
};
export type putListingFeatureSettingsMutationResponse = {
  readonly invsysPutListingFeatureSettings: {
    readonly success: boolean | null;
  };
};
export type putListingFeatureSettingsMutation = {
  readonly response: putListingFeatureSettingsMutationResponse;
  readonly variables: putListingFeatureSettingsMutationVariables;
};

/*
mutation putListingFeatureSettingsMutation(
  $currencyCode: InvsysListingCurrencyCodeTypePutObject
  $sizeUnit: InvsysSizeUnitTypePutObject
  $weightUnit: InvsysWeightUnitTypePutObject
  $weight: InvsysFloatPutObject
  $shippingProviders: InvsysArray_IntRequired_PutObject
  $descriptionTemplate: InvsysStringPutObject
  $privateNoteTemplate: InvsysStringPutObject
  $packageSizeType: InvsysIntPutObject
  $packageCustomLength: InvsysFloatPutObject
  $packageCustomWidth: InvsysFloatPutObject
  $packageCustomHeight: InvsysFloatPutObject
  $marketplaces: InvsysArray_IntRequired_PutObject
  $poshmarkShippingDiscountId: InvsysStringPutObject
  $mercariShippingType: InvsysIntPutObject
  $mercariShippingPayerId: InvsysIntPutObject
  $depopShippingType: InvsysIntPutObject
  $depopNationalShippingPrice: InvsysIntPutObject
  $depopInternationalShippingPrice: InvsysIntPutObject
  $tradesyShippingType: InvsysIntPutObject
  $tradesyShippingPrice: InvsysIntPutObject
  $grailedShippingType: InvsysIntPutObject
  $grailedUsShippingPrice: InvsysIntPutObject
  $grailedCaShippingPrice: InvsysIntPutObject
) {
  invsysPutListingFeatureSettings(currencyCode: $currencyCode, sizeUnit: $sizeUnit, weightUnit: $weightUnit, weight: $weight, shippingProviders: $shippingProviders, descriptionTemplate: $descriptionTemplate, privateNoteTemplate: $privateNoteTemplate, packageSizeType: $packageSizeType, packageCustomLength: $packageCustomLength, packageCustomWidth: $packageCustomWidth, packageCustomHeight: $packageCustomHeight, marketplaces: $marketplaces, poshmarkShippingDiscountId: $poshmarkShippingDiscountId, mercariShippingType: $mercariShippingType, mercariShippingPayerId: $mercariShippingPayerId, depopShippingType: $depopShippingType, depopNationalShippingPrice: $depopNationalShippingPrice, depopInternationalShippingPrice: $depopInternationalShippingPrice, tradesyShippingType: $tradesyShippingType, tradesyShippingPrice: $tradesyShippingPrice, grailedShippingType: $grailedShippingType, grailedUsShippingPrice: $grailedUsShippingPrice, grailedCaShippingPrice: $grailedCaShippingPrice) {
    success
  }
}
*/

const node: ConcreteRequest = (function () {
  var v0 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'currencyCode',
    },
    v1 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'depopInternationalShippingPrice',
    },
    v2 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'depopNationalShippingPrice',
    },
    v3 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'depopShippingType',
    },
    v4 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'descriptionTemplate',
    },
    v5 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'grailedCaShippingPrice',
    },
    v6 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'grailedShippingType',
    },
    v7 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'grailedUsShippingPrice',
    },
    v8 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'marketplaces',
    },
    v9 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'mercariShippingPayerId',
    },
    v10 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'mercariShippingType',
    },
    v11 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'packageCustomHeight',
    },
    v12 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'packageCustomLength',
    },
    v13 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'packageCustomWidth',
    },
    v14 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'packageSizeType',
    },
    v15 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'poshmarkShippingDiscountId',
    },
    v16 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'privateNoteTemplate',
    },
    v17 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'shippingProviders',
    },
    v18 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'sizeUnit',
    },
    v19 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'tradesyShippingPrice',
    },
    v20 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'tradesyShippingType',
    },
    v21 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'weight',
    },
    v22 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'weightUnit',
    },
    v23 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'currencyCode',
            variableName: 'currencyCode',
          },
          {
            kind: 'Variable',
            name: 'depopInternationalShippingPrice',
            variableName: 'depopInternationalShippingPrice',
          },
          {
            kind: 'Variable',
            name: 'depopNationalShippingPrice',
            variableName: 'depopNationalShippingPrice',
          },
          {
            kind: 'Variable',
            name: 'depopShippingType',
            variableName: 'depopShippingType',
          },
          {
            kind: 'Variable',
            name: 'descriptionTemplate',
            variableName: 'descriptionTemplate',
          },
          {
            kind: 'Variable',
            name: 'grailedCaShippingPrice',
            variableName: 'grailedCaShippingPrice',
          },
          {
            kind: 'Variable',
            name: 'grailedShippingType',
            variableName: 'grailedShippingType',
          },
          {
            kind: 'Variable',
            name: 'grailedUsShippingPrice',
            variableName: 'grailedUsShippingPrice',
          },
          {
            kind: 'Variable',
            name: 'marketplaces',
            variableName: 'marketplaces',
          },
          {
            kind: 'Variable',
            name: 'mercariShippingPayerId',
            variableName: 'mercariShippingPayerId',
          },
          {
            kind: 'Variable',
            name: 'mercariShippingType',
            variableName: 'mercariShippingType',
          },
          {
            kind: 'Variable',
            name: 'packageCustomHeight',
            variableName: 'packageCustomHeight',
          },
          {
            kind: 'Variable',
            name: 'packageCustomLength',
            variableName: 'packageCustomLength',
          },
          {
            kind: 'Variable',
            name: 'packageCustomWidth',
            variableName: 'packageCustomWidth',
          },
          {
            kind: 'Variable',
            name: 'packageSizeType',
            variableName: 'packageSizeType',
          },
          {
            kind: 'Variable',
            name: 'poshmarkShippingDiscountId',
            variableName: 'poshmarkShippingDiscountId',
          },
          {
            kind: 'Variable',
            name: 'privateNoteTemplate',
            variableName: 'privateNoteTemplate',
          },
          {
            kind: 'Variable',
            name: 'shippingProviders',
            variableName: 'shippingProviders',
          },
          {
            kind: 'Variable',
            name: 'sizeUnit',
            variableName: 'sizeUnit',
          },
          {
            kind: 'Variable',
            name: 'tradesyShippingPrice',
            variableName: 'tradesyShippingPrice',
          },
          {
            kind: 'Variable',
            name: 'tradesyShippingType',
            variableName: 'tradesyShippingType',
          },
          {
            kind: 'Variable',
            name: 'weight',
            variableName: 'weight',
          },
          {
            kind: 'Variable',
            name: 'weightUnit',
            variableName: 'weightUnit',
          },
        ],
        concreteType: 'InvsysPutListingFeatureSettingsResponse',
        kind: 'LinkedField',
        name: 'invsysPutListingFeatureSettings',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'success',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: [
        v0 /*: any*/,
        v1 /*: any*/,
        v2 /*: any*/,
        v3 /*: any*/,
        v4 /*: any*/,
        v5 /*: any*/,
        v6 /*: any*/,
        v7 /*: any*/,
        v8 /*: any*/,
        v9 /*: any*/,
        v10 /*: any*/,
        v11 /*: any*/,
        v12 /*: any*/,
        v13 /*: any*/,
        v14 /*: any*/,
        v15 /*: any*/,
        v16 /*: any*/,
        v17 /*: any*/,
        v18 /*: any*/,
        v19 /*: any*/,
        v20 /*: any*/,
        v21 /*: any*/,
        v22 /*: any*/,
      ],
      kind: 'Fragment',
      metadata: null,
      name: 'putListingFeatureSettingsMutation',
      selections: v23 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: [
        v0 /*: any*/,
        v18 /*: any*/,
        v22 /*: any*/,
        v21 /*: any*/,
        v17 /*: any*/,
        v4 /*: any*/,
        v16 /*: any*/,
        v14 /*: any*/,
        v12 /*: any*/,
        v13 /*: any*/,
        v11 /*: any*/,
        v8 /*: any*/,
        v15 /*: any*/,
        v10 /*: any*/,
        v9 /*: any*/,
        v3 /*: any*/,
        v2 /*: any*/,
        v1 /*: any*/,
        v20 /*: any*/,
        v19 /*: any*/,
        v6 /*: any*/,
        v7 /*: any*/,
        v5 /*: any*/,
      ],
      kind: 'Operation',
      name: 'putListingFeatureSettingsMutation',
      selections: v23 /*: any*/,
    },
    params: {
      cacheID: '05f8e8f2d913d806e0a372eb893f15e8',
      id: null,
      metadata: {},
      name: 'putListingFeatureSettingsMutation',
      operationKind: 'mutation',
      text: 'mutation putListingFeatureSettingsMutation(\n  $currencyCode: InvsysListingCurrencyCodeTypePutObject\n  $sizeUnit: InvsysSizeUnitTypePutObject\n  $weightUnit: InvsysWeightUnitTypePutObject\n  $weight: InvsysFloatPutObject\n  $shippingProviders: InvsysArray_IntRequired_PutObject\n  $descriptionTemplate: InvsysStringPutObject\n  $privateNoteTemplate: InvsysStringPutObject\n  $packageSizeType: InvsysIntPutObject\n  $packageCustomLength: InvsysFloatPutObject\n  $packageCustomWidth: InvsysFloatPutObject\n  $packageCustomHeight: InvsysFloatPutObject\n  $marketplaces: InvsysArray_IntRequired_PutObject\n  $poshmarkShippingDiscountId: InvsysStringPutObject\n  $mercariShippingType: InvsysIntPutObject\n  $mercariShippingPayerId: InvsysIntPutObject\n  $depopShippingType: InvsysIntPutObject\n  $depopNationalShippingPrice: InvsysIntPutObject\n  $depopInternationalShippingPrice: InvsysIntPutObject\n  $tradesyShippingType: InvsysIntPutObject\n  $tradesyShippingPrice: InvsysIntPutObject\n  $grailedShippingType: InvsysIntPutObject\n  $grailedUsShippingPrice: InvsysIntPutObject\n  $grailedCaShippingPrice: InvsysIntPutObject\n) {\n  invsysPutListingFeatureSettings(currencyCode: $currencyCode, sizeUnit: $sizeUnit, weightUnit: $weightUnit, weight: $weight, shippingProviders: $shippingProviders, descriptionTemplate: $descriptionTemplate, privateNoteTemplate: $privateNoteTemplate, packageSizeType: $packageSizeType, packageCustomLength: $packageCustomLength, packageCustomWidth: $packageCustomWidth, packageCustomHeight: $packageCustomHeight, marketplaces: $marketplaces, poshmarkShippingDiscountId: $poshmarkShippingDiscountId, mercariShippingType: $mercariShippingType, mercariShippingPayerId: $mercariShippingPayerId, depopShippingType: $depopShippingType, depopNationalShippingPrice: $depopNationalShippingPrice, depopInternationalShippingPrice: $depopInternationalShippingPrice, tradesyShippingType: $tradesyShippingType, tradesyShippingPrice: $tradesyShippingPrice, grailedShippingType: $grailedShippingType, grailedUsShippingPrice: $grailedUsShippingPrice, grailedCaShippingPrice: $grailedCaShippingPrice) {\n    success\n  }\n}\n',
    },
  };
})();
(node as any).hash = '712f7ff74ee49156040ee8f92b69de22';
export default node;
